import { render, staticRenderFns } from "./OpenAccount.vue?vue&type=template&id=23728a30&scoped=true"
import script from "./OpenAccount.vue?vue&type=script&lang=js"
export * from "./OpenAccount.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./OpenAccount.vue?vue&type=style&index=1&id=23728a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23728a30",
  null
  
)

export default component.exports